import React from 'react'
import { NavigationItem } from '../../../NavigationItems/NavigationItems/NavigationItem'

export const Navigation = () => {

    return (
        <div className="flex w-full justify-between pr-28 py-10 pl-10">
            <NavigationItem className="text-white" link="/home" >00 HOME</NavigationItem>
            <NavigationItem link="/destination" >01 DESTINATION</NavigationItem>
            <NavigationItem link="/crew" >02 CREW</NavigationItem>
            <NavigationItem link="/technology" >03 TECHNOLOGY</NavigationItem>
        </div>
    )
}
